import {TranslationObject} from '@colonist/i18n'
import {setElementInnerHTML} from '../../../../shared/scripts/ui_utils/DomUtils'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {PlayerEnums} from '../../../../../shared/GameEnums'
import RoomInfoMessage = PlayerEnums.RoomInfoMessage
import {UIDiscordInstance} from '../../discord/child_iframe/UIDiscordInstance'
import {ViewPopupBecomeMemberGameplay} from '../../../../shared/scripts/ui_popup/ViewPopupBecomeMemberGameplay'
import {SDKRequest} from '../../../../../shared/DiscordActivityTypes'
import {ColonistMembershipType} from '@colonist/types'

export class UIRoomCenterInfoMessageController {
    private readonly container: HTMLDivElement
    private readonly infoMessage: HTMLParagraphElement

    constructor() {
        this.container = document.getElementsByClassName('room-center-footer')[0] as HTMLDivElement
        this.infoMessage = document.getElementById('room-info-message') as HTMLParagraphElement
    }

    setMessage(message: RoomInfoMessage) {
        switch(message) {
            case RoomInfoMessage.None: this.hide(); return
            case RoomInfoMessage.ClickReady: this.setClickReadyMessage(); break
            case RoomInfoMessage.PremiumItemSelected: this.setPremiumItemMessage(); break
        }
        this.show()
    }

    private show() {
        this.container.classList.add('show-message')
    }

    private hide() {
        this.container.classList.remove('show-message')
    }

    private setClickReadyMessage() {
        const message: TranslationObject = {key: 'strings:roomPage.allPlayersNeedToBeReady'}
        setElementInnerHTML(this.infoMessage, message)
    }

    private setPremiumItemMessage() {
        const message: TranslationObject = {key: 'strings:roomPage.premiumItemNotOwned'}
        setElementInnerHTML(this.infoMessage, message)
        this.setPremiumItemCTA()
    }

    private setPremiumItemCTA() {
        const cta = this.infoMessage.querySelector('#premium-item-cta') as HTMLLinkElement
        if(cta == null) return

        cta.onclick = () => {
            if(UIUtilsEjsVariables.isUserOnDiscord) {
                const checkAction = () => {
                    void UIDiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.PremiumMonthly)
                }
                new ViewPopupBecomeMemberGameplay(checkAction, AnalyticEventValue.PopupMembershipIncentiveDiscordGeneral)
            }
            void UIRoomCenterInfoMessageController.sendBecomeMemberAnalyticEvent()
        }

        if(UIUtilsEjsVariables.isUserOnDiscord) cta.removeAttribute('href')
    }

    private static async sendBecomeMemberAnalyticEvent() {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.RoomPremiumItemInfoMessageBecomeAMemberText,
        }
        void CA.sendAnalyticEvent(eventData)
    }
}
